module.exports = __webpack_public_path__ + "media/item03.93a3f6b8.webm";